import React from 'react'
import { colors } from '../../styles/utilities/variables'
import { StyledCircleHeart } from './style'
export const getColor = color => {
  return color ? colors[color] : colors.black
}

export const CheckMarkIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <circle cx='7.5' cy='22.5' r='1.5' />
      <circle cx='10.5' cy='19.5' r='1.5' />
      <circle cx='4.5' cy='19.5' r='1.5' />
      <circle cx='1.5' cy='16.5' r='1.5' />
      <circle cx='13.5' cy='16.5' r='1.5' />
      <circle cx='16.5' cy='13.5' r='1.5' />
      <circle cx='19.5' cy='10.5' r='1.5' />
      <circle cx='22.5' cy='7.5' r='1.5' />
    </svg>
  )
}

export const CartIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <circle cx='21.5' cy='22.5' r='1.5' />
      <circle cx='21.5' cy='18.5' r='1.5' />
      <circle cx='21.5' cy='14.5' r='1.5' />
      <circle cx='21.5' cy='10.5' r='1.5' />
      <circle cx='17.5' cy='22.5' r='1.5' />
      <circle cx='13.5' cy='22.5' r='1.5' />
      <circle cx='9.5' cy='22.5' r='1.5' />
      <circle cx='5.5' cy='22.5' r='1.5' />
      <circle cx='1.5' cy='22.5' r='1.5' />
      <circle cx='1.5' cy='18.5' r='1.5' />
      <circle cx='1.5' cy='14.5' r='1.5' />
      <circle cx='1.5' cy='10.5' r='1.5' />
      <circle cx='5.5' cy='10.5' r='1.5' />
      <circle cx='3.5' cy='6.5' r='1.5' />
      <circle cx='19.5' cy='6.5' r='1.5' />
      <circle cx='9.5' cy='10.5' r='1.5' />
      <circle cx='13.5' cy='10.5' r='1.5' />
      <circle cx='7.5' cy='2.5' r='1.5' />
      <circle cx='11.5' cy='2.5' r='1.5' />
      <circle cx='15.5' cy='2.5' r='1.5' />
      <circle cx='17.5' cy='10.5' r='1.5' />
    </svg>
  )
}

export const CartFilledIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <path
        d='M3.5 8C4.32843 8 5 7.32843 5 6.5C5 5.67157 4.32843 5 3.5 5C2.67157 5 2 5.67157 2 6.5C2 7.32843 2.67157 8 3.5 8Z'
        fill={getColor(color)}
      />
      <path
        d='M19.5 8C20.3284 8 21 7.32843 21 6.5C21 5.67157 20.3284 5 19.5 5C18.6716 5 18 5.67157 18 6.5C18 7.32843 18.6716 8 19.5 8Z'
        fill={getColor(color)}
      />
      <path
        d='M7.5 4C8.32843 4 9 3.32843 9 2.5C9 1.67157 8.32843 1 7.5 1C6.67157 1 6 1.67157 6 2.5C6 3.32843 6.67157 4 7.5 4Z'
        fill={getColor(color)}
      />
      <path
        d='M11.5 4C12.3284 4 13 3.32843 13 2.5C13 1.67157 12.3284 1 11.5 1C10.6716 1 10 1.67157 10 2.5C10 3.32843 10.6716 4 11.5 4Z'
        fill={getColor(color)}
      />
      <path
        d='M15.5 4C16.3284 4 17 3.32843 17 2.5C17 1.67157 16.3284 1 15.5 1C14.6716 1 14 1.67157 14 2.5C14 3.32843 14.6716 4 15.5 4Z'
        fill={getColor(color)}
      />
      <rect y='9' width='23' height='15' rx='1.5' fill={getColor(color)} />
    </svg>
  )
}

export const HamburgerIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <circle className={id + '_lower'} cx='21.5' cy='19.51' r='1.5' />
      <circle className={id + '_lower'} cx='17.5' cy='19.51' r='1.5' />
      <circle className={id + '_lower'} cx='13.5' cy='19.51' r='1.5' />
      <circle className={id + '_lower'} cx='9.5' cy='19.51' r='1.5' />
      <circle className={id + '_lower'} cx='5.5' cy='19.51' r='1.5' />
      <circle className={id + '_lower'} cx='1.5' cy='19.51' r='1.5' />
      <circle className={id + '_center'} cx='21.5' cy='12.5' r='1.5' />
      <circle className={id + '_center'} cx='17.5' cy='12.5' r='1.5' />
      <circle className={id + '_center'} cx='13.5' cy='12.5' r='1.5' />
      <circle className={id + '_center'} cx='9.5' cy='12.5' r='1.5' />
      <circle className={id + '_center'} cx='5.5' cy='12.5' r='1.5' />
      <circle className={id + '_center'} cx='1.5' cy='12.5' r='1.5' />
      <circle className={id + '_upper'} cx='21.5' cy='5.44' r='1.5' />
      <circle className={id + '_upper'} cx='17.5' cy='5.44' r='1.5' />
      <circle className={id + '_upper'} cx='13.5' cy='5.44' r='1.5' />
      <circle className={id + '_upper'} cx='9.5' cy='5.44' r='1.5' />
      <circle className={id + '_upper'} cx='5.5' cy='5.44' r='1.5' />
      <circle className={id + '_upper'} cx='1.5' cy='5.44' r='1.5' />
    </svg>
  )
}

export const SearchIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <circle cx='3.5' cy='3.5' r='1.5' />
      <circle cx='1.5' cy='7.5' r='1.5' />
      <circle cx='17.5' cy='11.5' r='1.5' />
      <circle cx='17.5' cy='7.5' r='1.5' />
      <circle cx='1.5' cy='11.5' r='1.5' />
      <circle cx='19.5' cy='19.5' r='1.5' />
      <circle cx='16.5' cy='16.5' r='1.5' />
      <circle cx='22.5' cy='22.5' r='1.5' />
      <circle cx='15.5' cy='3.5' r='1.5' />
      <circle cx='11.5' cy='1.5' r='1.5' />
      <circle cx='7.5' cy='17.5' r='1.5' />
      <circle cx='11.5' cy='17.5' r='1.5' />
      <circle cx='7.5' cy='1.5' r='1.5' />
      <circle cx='3.5' cy='15.5' r='1.5' />
    </svg>
  )
}

export const ChatIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      fill={getColor(color)}
    >
      <circle cx='2.59' cy='4.5' r='1.5' />
      <circle cx='1.54' cy='8.5' r='1.5' />
      <circle cx='2.56' cy='12.5' r='1.5' />
      <circle cx='17.54' cy='1.5' r='1.5' />
      <circle cx='20.5' cy='4.5' r='1.5' />
      <circle cx='21.54' cy='8.5' r='1.5' />
      <circle cx='20.55' cy='12.5' r='1.5' />
      <circle cx='18.52' cy='16.5' r='1.5' />
      <circle cx='13.54' cy='15.5' r='1.5' />
      <circle cx='9.54' cy='15.5' r='1.5' />
      <circle cx='15.52' cy='19.5' r='1.5' />
      <circle cx='12.52' cy='22.5' r='1.5' />
      <circle cx='5.54' cy='15.5' r='1.5' />
      <circle cx='13.54' cy='1.5' r='1.5' />
      <circle cx='9.54' cy='1.5' r='1.5' />
      <circle cx='5.54' cy='1.5' r='1.5' />
    </svg>
  )
}

export const LockOpenIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <circle cx='21.42' cy='22.5' r='1.5' />
      <circle cx='21.42' cy='18.5' r='1.5' />
      <circle cx='21.42' cy='14.5' r='1.5' />
      <circle cx='17.42' cy='22.5' r='1.5' />
      <circle cx='13.42' cy='22.5' r='1.5' />
      <circle cx='9.42' cy='22.5' r='1.5' />
      <circle cx='5.42' cy='22.5' r='1.5' />
      <circle cx='1.42' cy='22.5' r='1.5' />
      <circle cx='1.42' cy='18.5' r='1.5' />
      <circle cx='1.42' cy='14.5' r='1.5' />
      <circle cx='1.42' cy='2.5' r='1.5' />
      <circle cx='5.42' cy='2.5' r='1.5' />
      <circle cx='9.42' cy='2.5' r='1.5' />
      <circle cx='9.42' cy='6.5' r='1.5' />
      <circle cx='7.44' cy='10.5' r='1.5' />
      <circle cx='3.44' cy='10.5' r='1.5' />
      <circle cx='7.44' cy='10.5' r='1.5' />
      <circle cx='11.44' cy='10.5' r='1.5' />
      <circle cx='15.44' cy='10.5' r='1.5' />
      <circle cx='19.4' cy='10.5' r='1.5' />
    </svg>
  )
}

export const LockClosedIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <circle cx='21.54' cy='22.5' r='1.5' />
      <circle cx='21.54' cy='18.5' r='1.5' />
      <circle cx='21.54' cy='14.5' r='1.5' />
      <circle cx='17.54' cy='22.5' r='1.5' />
      <circle cx='13.54' cy='22.5' r='1.5' />
      <circle cx='9.54' cy='22.5' r='1.5' />
      <circle cx='5.54' cy='22.5' r='1.5' />
      <circle cx='1.54' cy='22.5' r='1.5' />
      <circle cx='1.54' cy='18.5' r='1.5' />
      <circle cx='1.54' cy='14.5' r='1.5' />
      <circle cx='7.54' cy='2.5' r='1.5' />
      <circle cx='11.54' cy='2.5' r='1.5' />
      <circle cx='7.54' cy='6.5' r='1.5' />
      <circle cx='15.54' cy='2.5' r='1.5' />
      <circle cx='15.54' cy='6.5' r='1.5' />
      <circle cx='3.56' cy='10.48' r='1.5' />
      <circle cx='7.56' cy='10.48' r='1.5' />
      <circle cx='11.56' cy='10.48' r='1.5' />
      <circle cx='15.56' cy='10.48' r='1.5' />
      <circle cx='19.48' cy='10.48' r='1.5' />
    </svg>
  )
}

export const MailIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <circle cx='21.5' cy='20.5' r='1.5' />
      <circle cx='17.5' cy='20.5' r='1.5' />
      <circle cx='13.5' cy='20.5' r='1.5' />
      <circle cx='9.5' cy='20.5' r='1.5' />
      <circle cx='5.5' cy='20.5' r='1.5' />
      <circle cx='1.5' cy='20.5' r='1.5' />
      <circle cx='21.5' cy='12.5' r='1.5' />
      <circle cx='1.5' cy='12.5' r='1.5' />
      <circle cx='21.5' cy='4.5' r='1.5' />
      <circle cx='21.5' cy='8.5' r='1.5' />
      <circle cx='21.5' cy='16.5' r='1.5' />
      <circle cx='17.5' cy='4.5' r='1.5' />
      <circle cx='13.5' cy='4.5' r='1.5' />
      <circle cx='9.5' cy='4.5' r='1.5' />
      <circle cx='5.5' cy='4.5' r='1.5' />
      <circle cx='1.5' cy='4.5' r='1.5' />
      <circle cx='1.5' cy='16.5' r='1.5' />
      <circle cx='1.5' cy='8.5' r='1.5' />
      <circle cx='5.5' cy='8.5' r='1.5' />
      <circle cx='8.5' cy='11.5' r='1.5' />
      <circle cx='11.5' cy='14.5' r='1.5' />
      <circle cx='14.5' cy='11.5' r='1.5' />
      <circle cx='17.5' cy='8.5' r='1.5' />
    </svg>
  )
}

export const PlaceIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <circle cx='11.5' cy='22.5' r='1.5' />
      <circle cx='11.5' cy='1.54' r='1.5' />
      <circle cx='15.5' cy='2.5' r='1.5' />
      <circle cx='7.5' cy='2.5' r='1.5' />
      <circle cx='18.5' cy='6.5' r='1.5' />
      <circle cx='4.5' cy='6.5' r='1.5' />
      <circle cx='14.5' cy='6.5' r='1.5' />
      <circle cx='17.5' cy='10.5' r='1.5' />
      <circle cx='5.5' cy='10.5' r='1.5' />
      <circle cx='13.5' cy='10.5' r='1.5' />
      <circle cx='9.5' cy='10.5' r='1.5' />
      <circle cx='7.5' cy='14.5' r='1.5' />
      <circle cx='15.5' cy='14.5' r='1.5' />
      <circle cx='11.5' cy='14.5' r='1.5' />
      <circle cx='9.5' cy='18.5' r='1.5' />
      <circle cx='13.5' cy='18.5' r='1.5' />
    </svg>
  )
}

export const LikeIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 46 46'
      fill={getColor(color)}
    >
      <g fill='#ED6763' clip-path='url(#a)'>
        <path d='M23 46c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M31 38c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M23 38c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M15 38c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M17 6c1.6569 0 3-1.3431 3-3 0-1.6568-1.3431-3-3-3s-3 1.3432-3 3c0 1.6569 1.3431 3 3 3Z' />
        <path d='M9 6c1.6569 0 3-1.3431 3-3 0-1.6568-1.3431-3-3-3S6 1.3432 6 3c0 1.6569 1.3431 3 3 3Z' />
        <path d='M37 6c1.6569 0 3-1.3431 3-3 0-1.6568-1.3431-3-3-3s-3 1.3432-3 3c0 1.6569 1.3431 3 3 3Z' />
        <path d='M29 6c1.6569 0 3-1.3431 3-3 0-1.6568-1.3431-3-3-3s-3 1.3432-3 3c0 1.6569 1.3431 3 3 3Z' />
        <path d='M43 14c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M35 14c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M11 14c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M3 14c1.6569 0 3-1.3431 3-3S4.6569 8 3 8c-1.6568 0-3 1.3431-3 3s1.3432 3 3 3Z' />
        <path d='M27 14c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M19 14c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M43 22c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M35 22c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M11 22c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M3 22c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3c-1.6568 0-3 1.3431-3 3s1.3432 3 3 3Z' />
        <path d='M27 22c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M19 22c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M39 30c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M31 30c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M23 30c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M15 30c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
        <path d='M7 30c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z' />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M0 0h46v46H0z' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ChatActiveIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <circle cx='7.5' cy='8.5' r='1.5' />
      <circle cx='11.52' cy='8.5' r='1.5' />
      <circle cx='15.59' cy='8.5' r='1.5' />
      <circle cx='2.5' cy='4.5' r='1.5' />
      <circle cx='1.5' cy='8.5' r='1.5' />
      <circle cx='2.5' cy='12.5' r='1.5' />
      <circle cx='17.5' cy='1.5' r='1.5' />
      <circle cx='20.5' cy='4.5' r='1.5' />
      <circle cx='21.5' cy='8.5' r='1.5' />
      <circle cx='20.5' cy='12.5' r='1.5' />
      <circle cx='18.5' cy='16.5' r='1.5' />
      <circle cx='13.5' cy='15.5' r='1.5' />
      <circle cx='9.5' cy='15.5' r='1.5' />
      <circle cx='15.5' cy='19.5' r='1.5' />
      <circle cx='12.5' cy='22.5' r='1.5' />
      <circle cx='5.5' cy='15.5' r='1.5' />
      <circle cx='13.5' cy='1.5' r='1.5' />
      <circle cx='9.5' cy='1.5' r='1.5' />
      <circle cx='5.5' cy='1.5' r='1.5' />
    </svg>
  )
}

export const PlusIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <circle cx='4.06' cy='12' r='1.5' />
      <circle cx='8.03' cy='12' r='1.5' />
      <circle cx='12' cy='12' r='1.5' />
      <circle cx='15.96' cy='12' r='1.5' />
      <circle cx='19.94' cy='12' r='1.5' />
      <circle cx='12' cy='19.93' r='1.5' />
      <circle cx='12' cy='15.97' r='1.5' />
      <circle cx='12' cy='8.03' r='1.5' />
      <circle cx='12' cy='4.06' r='1.5' />
    </svg>
  )
}

export const MinusIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill={getColor(color)}
    >
      <circle cx='4.06' cy='12' r='1.5' />
      <circle cx='8.03' cy='12' r='1.5' />
      <circle cx='12' cy='12' r='1.5' />
      <circle cx='15.96' cy='12' r='1.5' />
      <circle cx='19.94' cy='12' r='1.5' />
    </svg>
  )
}

export const Logo = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width='244'
      height='36'
      viewBox='0 0 244 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M71 9.90002V26.2H68.2L59.2 15.7V26.2H55.9V9.90002H58.7L67.7 20.7V9.90002H71Z'
        fill={getColor(color)}
      />
      <path
        d='M85.7 21.0001H76.4C76.7 22.8001 78 23.8001 79.4 23.8001C80.4 23.8001 81.5 23.7001 82.4 22.2001L85.3 22.8001C84.2 25.3001 82.1 26.6001 79.4 26.6001C76 26.6001 73.2 24.0001 73.2 20.2001C73.2 16.4001 76 13.7001 79.5 13.7001C82.7 13.7001 85.5 16.2001 85.7 19.9001V21.0001ZM76.5 18.7001H82.4C82 17.1001 80.8 16.5001 79.5 16.5001C78.3 16.5001 76.9 17.2001 76.5 18.7001Z'
        fill={getColor(color)}
      />
      <path
        d='M104 14L100 26.2H97.1L94.7 19L92.3 26.2H89.4L85.4 14H88.6L91 21.5L93.5 14H96L98.5 21.5L100.9 14H104Z'
        fill={getColor(color)}
      />
      <path
        d='M118.5 20.1C118.5 23.9 115.6 26.5 112.5 26.5C110.8 26.5 109.5 26 108.5 25.2V26.2H105.3V8.59998H108.5V15C109.5 14.1 110.9 13.7 112.5 13.7C115.6 13.7 118.5 16.3 118.5 20.1ZM115.4 20.1C115.4 17.9 113.9 16.4 112 16.4C110.3 16.4 108.5 17.8 108.5 20.1C108.5 22.3 110.2 23.7 112 23.7C113.9 23.7 115.4 22.4 115.4 20.1Z'
        fill={getColor(color)}
      />
      <path
        d='M132.7 20.1001C132.7 23.9001 129.7 26.5001 126.1 26.5001C122.5 26.5001 119.5 23.9001 119.5 20.1001C119.5 16.3001 122.5 13.7001 126.1 13.7001C129.7 13.7001 132.7 16.3001 132.7 20.1001ZM129.5 20.1001C129.5 17.8001 127.7 16.5001 126.1 16.5001C124.3 16.5001 122.6 17.9001 122.6 20.1001C122.6 22.4001 124.4 23.7001 126.1 23.7001C127.8 23.7001 129.5 22.4001 129.5 20.1001Z'
        fill={getColor(color)}
      />
      <path
        d='M146.7 8.60003V26.1H143.5V25.1C142.5 25.9 141.1 26.4 139.5 26.4C136.4 26.4 133.5 23.8 133.5 20C133.5 16.2 136.4 13.5 139.5 13.5C141.2 13.5 142.5 14 143.5 14.8V8.40002H146.7V8.60003ZM143.5 20.1C143.5 17.9 141.8 16.4 140 16.4C138.1 16.4 136.6 17.8 136.6 20.1C136.6 22.3 138.1 23.7 140 23.7C141.8 23.7 143.5 22.4 143.5 20.1Z'
        fill={getColor(color)}
      />
      <path
        d='M161.7 14L154.3 31H150.7L153 25.7L148 14H151.6L154.8 21.8L158.2 14H161.7Z'
        fill={getColor(color)}
      />
      <path
        d='M172.2 12.9V16.9H180.1V19.9H172.2V26.2H168.9V9.90002H181V12.9H172.2Z'
        fill={getColor(color)}
      />
      <path
        d='M194.8 14V26.2H191.6V25.2C190.6 26 189.2 26.5 187.6 26.5C184.5 26.5 181.6 23.9 181.6 20.1C181.6 16.3 184.5 13.6 187.6 13.6C189.3 13.6 190.6 14.1 191.6 14.9V13.9H194.8V14ZM191.6 20.1C191.6 17.9 189.9 16.4 188.1 16.4C186.2 16.4 184.7 17.8 184.7 20.1C184.7 22.3 186.2 23.7 188.1 23.7C189.9 23.7 191.6 22.4 191.6 20.1Z'
        fill={getColor(color)}
      />
      <path
        d='M217 18.6V26.2H213.8V19.3C213.8 17.7 212.8 16.7 211.4 16.7C209.7 16.7 208.6 17.9 208.6 20.4V26.2H205.4V19.3C205.4 17.7 204.4 16.7 203 16.7C201.3 16.7 200.2 17.9 200.2 20.4V26.2H197V14H200.2V15C201.1 14.1 202.2 13.6 203.8 13.6C205.4 13.6 206.9 14.3 207.8 15.6C208.8 14.4 210.3 13.6 212.2 13.6C214.8 13.7 217 15.6 217 18.6Z'
        fill={getColor(color)}
      />
      <path
        d='M222.9 10.4C222.9 11.5 222.1 12.3 221 12.3C219.9 12.3 219.1 11.5 219.1 10.4C219.1 9.4 219.9 8.5 221 8.5C222 8.5 222.9 9.4 222.9 10.4ZM222.5 26.2H219.3V14H222.5V26.2Z'
        fill={getColor(color)}
      />
      <path d='M228.5 26.2H225.3V8.59998H228.5V26.2Z' fill={getColor(color)} />
      <path
        d='M243.4 14L236 31H232.4L234.7 25.7L229.7 13.9H233.3L236.5 21.7L239.9 13.9H243.4V14Z'
        fill={getColor(color)}
      />
      <path
        d='M17.1 13.4C18.3 13.4 19.3 12.4 19.3 11.2C19.3 10 18.3 9 17.1 9C16 9 15 10 15 11.2C15 11.8 15.2 12.3 15.6 12.7C16 13.1 16.6 13.4 17.1 13.4Z'
        fill={getColor(color)}
      />
      <path
        d='M12 34.2C13 34.2 13.9 33.4 13.9 32.4C13.9 31.4 13.1 30.5 12.1 30.5C11.1 30.5 10.3 31.3 10.2 32.3C10.2 32.8 10.4 33.3 10.7 33.6C11 34 11.5 34.2 12 34.2Z'
        fill={getColor(color)}
      />
      <path
        d='M12 5.99993C13 5.99993 13.9 5.19993 13.9 4.19993C13.9 3.19993 13.1 2.29993 12.1 2.29993C11.1 2.29993 10.3 3.09993 10.2 4.09993C10.2 4.59993 10.4 5.09993 10.7 5.39993C11 5.79993 11.5 5.99993 12 5.99993Z'
        fill={getColor(color)}
      />
      <path
        d='M12 20.0999C13 20.0999 13.9 19.2999 13.9 18.2999C13.9 17.2999 13.1 16.3999 12.1 16.3999C11.1 16.3999 10.3 17.1999 10.2 18.1999C10.2 18.6999 10.4 19.1999 10.7 19.4999C11 19.8999 11.5 20.0999 12 20.0999Z'
        fill={getColor(color)}
      />
      <path
        d='M6.8 26.7999C7.6 26.7999 8.3 26.0999 8.3 25.2999C8.3 24.4999 7.6 23.7999 6.8 23.7999C6 23.7999 5.3 24.4999 5.3 25.2999C5.3 25.6999 5.5 26.0999 5.7 26.3999C6 26.5999 6.4 26.7999 6.8 26.7999Z'
        fill={getColor(color)}
      />
      <path
        d='M27.5 28C29 28 30.3 26.8 30.3 25.3C30.3 23.8 29.1 22.5 27.6 22.5C26.1 22.5 24.8 23.7 24.8 25.2C24.8 25.9 25.1 26.6 25.6 27.2C26.1 27.7 26.8 28 27.5 28Z'
        fill={getColor(color)}
      />
      <path
        d='M17.2 13.4C18.415 13.4 19.4 12.415 19.4 11.2C19.4 9.98497 18.415 9 17.2 9C15.985 9 15 9.98497 15 11.2C15 12.415 15.985 13.4 17.2 13.4Z'
        fill={getColor(color)}
      />
      <path
        d='M12 20.1999C13.0493 20.1999 13.9 19.3492 13.9 18.2999C13.9 17.2506 13.0493 16.3999 12 16.3999C10.9507 16.3999 10.1 17.2506 10.1 18.2999C10.1 19.3492 10.9507 20.1999 12 20.1999Z'
        fill={getColor(color)}
      />
      <path
        d='M12 6.09993C13.0493 6.09993 13.9 5.24927 13.9 4.19993C13.9 3.15059 13.0493 2.29993 12 2.29993C10.9507 2.29993 10.1 3.15059 10.1 4.19993C10.1 5.24927 10.9507 6.09993 12 6.09993Z'
        fill={getColor(color)}
      />
      <path
        d='M12 34.1999C13.0493 34.1999 13.9 33.3492 13.9 32.2999C13.9 31.2506 13.0493 30.3999 12 30.3999C10.9507 30.3999 10.1 31.2506 10.1 32.2999C10.1 33.3492 10.9507 34.1999 12 34.1999Z'
        fill={getColor(color)}
      />
      <path
        d='M6.8 12.7C7.62843 12.7 8.3 12.0284 8.3 11.2C8.3 10.3715 7.62843 9.69995 6.8 9.69995C5.97158 9.69995 5.3 10.3715 5.3 11.2C5.3 12.0284 5.97158 12.7 6.8 12.7Z'
        fill={getColor(color)}
      />
      <path
        d='M6.8 26.7999C7.62843 26.7999 8.3 26.1284 8.3 25.2999C8.3 24.4715 7.62843 23.7999 6.8 23.7999C5.97158 23.7999 5.3 24.4715 5.3 25.2999C5.3 26.1284 5.97158 26.7999 6.8 26.7999Z'
        fill={getColor(color)}
      />
      <path
        d='M1.6 5.29997C2.20751 5.29997 2.7 4.80749 2.7 4.19998C2.7 3.59246 2.20751 3.09998 1.6 3.09998C0.992487 3.09998 0.5 3.59246 0.5 4.19998C0.5 4.80749 0.992487 5.29997 1.6 5.29997Z'
        fill={getColor(color)}
      />
      <path
        d='M1.6 19.4C2.20751 19.4 2.7 18.9075 2.7 18.2999C2.7 17.6924 2.20751 17.2 1.6 17.2C0.992487 17.2 0.5 17.6924 0.5 18.2999C0.5 18.9075 0.992487 19.4 1.6 19.4Z'
        fill={getColor(color)}
      />
      <path
        d='M1.6 33.4C2.20751 33.4 2.7 32.9075 2.7 32.2999C2.7 31.6924 2.20751 31.2 1.6 31.2C0.992487 31.2 0.5 31.6924 0.5 32.2999C0.5 32.9075 0.992487 33.4 1.6 33.4Z'
        fill={getColor(color)}
      />
      <path
        d='M22.4 20.7999C23.7807 20.7999 24.9 19.6806 24.9 18.2999C24.9 16.9192 23.7807 15.7999 22.4 15.7999C21.0193 15.7999 19.9 16.9192 19.9 18.2999C19.9 19.6806 21.0193 20.7999 22.4 20.7999Z'
        fill={getColor(color)}
      />
      <path
        d='M27.5 28.1C29.0464 28.1 30.3 26.8464 30.3 25.3C30.3 23.7536 29.0464 22.5 27.5 22.5C25.9536 22.5 24.7 23.7536 24.7 25.3C24.7 26.8464 25.9536 28.1 27.5 28.1Z'
        fill={getColor(color)}
      />
      <path
        d='M32.7 21.2999C34.3569 21.2999 35.7 19.9568 35.7 18.2999C35.7 16.6431 34.3569 15.2999 32.7 15.2999C31.0431 15.2999 29.7 16.6431 29.7 18.2999C29.7 19.9568 31.0431 21.2999 32.7 21.2999Z'
        fill={getColor(color)}
      />
      <path
        d='M32.7 35.2999C34.3569 35.2999 35.7 33.9568 35.7 32.2999C35.7 30.6431 34.3569 29.2999 32.7 29.2999C31.0431 29.2999 29.7 30.6431 29.7 32.2999C29.7 33.9568 31.0431 35.2999 32.7 35.2999Z'
        fill={getColor(color)}
      />
      <path
        d='M32.7 7.19995C34.3569 7.19995 35.7 5.85681 35.7 4.19995C35.7 2.5431 34.3569 1.19995 32.7 1.19995C31.0431 1.19995 29.7 2.5431 29.7 4.19995C29.7 5.85681 31.0431 7.19995 32.7 7.19995Z'
        fill={getColor(color)}
      />
      <path
        d='M38 21.8999C38 21.8999 37.9 21.8999 38 21.8999C37.1 21.8999 36.3 22.1999 35.6 22.8999C35 23.4999 34.6 24.3999 34.6 25.2999C34.6 26.1999 34.9 26.9999 35.6 27.6999C36.2 28.2999 37.1 28.6999 38 28.6999C39.8 28.6999 41.3 27.1999 41.4 25.3999C41.3 23.4999 39.8 21.8999 38 21.8999Z'
        fill={getColor(color)}
      />
      <path
        d='M37.9 14.5999C39.7778 14.5999 41.3 13.0777 41.3 11.1999C41.3 9.32216 39.7778 7.79993 37.9 7.79993C36.0222 7.79993 34.5 9.32216 34.5 11.1999C34.5 13.0777 36.0222 14.5999 37.9 14.5999Z'
        fill={getColor(color)}
      />
      <path
        d='M37.9 28.6999C39.7778 28.6999 41.3 27.1777 41.3 25.2999C41.3 23.4221 39.7778 21.8999 37.9 21.8999C36.0222 21.8999 34.5 23.4221 34.5 25.2999C34.5 27.1777 36.0222 28.6999 37.9 28.6999Z'
        fill={getColor(color)}
      />
      <path
        d='M43.1 7.49995C44.9778 7.49995 46.5 5.97772 46.5 4.09995C46.5 2.22218 44.9778 0.699951 43.1 0.699951C41.2222 0.699951 39.7 2.22218 39.7 4.09995C39.7 5.97772 41.2222 7.49995 43.1 7.49995Z'
        fill={getColor(color)}
      />
      <path
        d='M43.1 21.6999C44.9778 21.6999 46.5 20.1777 46.5 18.2999C46.5 16.4221 44.9778 14.8999 43.1 14.8999C41.2222 14.8999 39.7 16.4221 39.7 18.2999C39.7 20.1777 41.2222 21.6999 43.1 21.6999Z'
        fill={getColor(color)}
      />
      <path
        d='M43.1 35.6999C44.9778 35.6999 46.5 34.1777 46.5 32.2999C46.5 30.4221 44.9778 28.8999 43.1 28.8999C41.2222 28.8999 39.7 30.4221 39.7 32.2999C39.7 34.1777 41.2222 35.6999 43.1 35.6999Z'
        fill={getColor(color)}
      />
    </svg>
  )
}

export const IconLogo = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      viewBox='0 0 48 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.48922 12.1375C7.29829 12.1375 7.95418 11.4816 7.95418 10.6725C7.95418 9.86346 7.29829 9.20758 6.48922 9.20758C5.68014 9.20758 5.02426 9.86346 5.02426 10.6725C5.02426 11.4816 5.68014 12.1375 6.48922 12.1375Z'
        fill={getColor(color)}
      />
      <path
        d='M1.04715 4.60646C1.62548 4.60646 2.09431 4.13762 2.09431 3.55929C2.09431 2.98096 1.62548 2.51213 1.04715 2.51213C0.468826 2.51213 0 2.98096 0 3.55929C0 4.13762 0.468826 4.60646 1.04715 4.60646Z'
        fill={getColor(color)}
      />
      <path
        d='M1.04715 19.2561C1.62548 19.2561 2.09431 18.7872 2.09431 18.2089C2.09431 17.6306 1.62548 17.1617 1.04715 17.1617C0.468826 17.1617 0 17.6306 0 18.2089C0 18.7872 0.468826 19.2561 1.04715 19.2561Z'
        fill={getColor(color)}
      />
      <path
        d='M1.04715 33.4879C1.62548 33.4879 2.09431 33.0191 2.09431 32.4407C2.09431 31.8624 1.62548 31.3936 1.04715 31.3936C0.468826 31.3936 0 31.8624 0 32.4407C0 33.0191 0.468826 33.4879 1.04715 33.4879Z'
        fill={getColor(color)}
      />
      <path
        d='M22.6091 20.5095C23.9965 20.5095 25.1212 19.3848 25.1212 17.9973C25.1212 16.6099 23.9965 15.4852 22.6091 15.4852C21.2217 15.4852 20.097 16.6099 20.097 17.9973C20.097 19.3848 21.2217 20.5095 22.6091 20.5095Z'
        fill={getColor(color)}
      />
      <path
        d='M33.2816 21.3504C35.0166 21.3504 36.4231 19.9439 36.4231 18.2089C36.4231 16.4739 35.0166 15.0675 33.2816 15.0675C31.5467 15.0675 30.1402 16.4739 30.1402 18.2089C30.1402 19.9439 31.5467 21.3504 33.2816 21.3504Z'
        fill={getColor(color)}
      />
      <path
        d='M33.2816 35.5822C35.0166 35.5822 36.4231 34.1757 36.4231 32.4407C36.4231 30.7057 35.0166 29.2992 33.2816 29.2992C31.5467 29.2992 30.1402 30.7057 30.1402 32.4407C30.1402 34.1757 31.5467 35.5822 33.2816 35.5822Z'
        fill={getColor(color)}
      />
      <path
        d='M33.2816 6.70073C35.0166 6.70073 36.4231 5.29425 36.4231 3.55926C36.4231 1.82427 35.0166 0.417786 33.2816 0.417786C31.5467 0.417786 30.1402 1.82427 30.1402 3.55926C30.1402 5.29425 31.5467 6.70073 33.2816 6.70073Z'
        fill={getColor(color)}
      />
      <path
        d='M38.7237 14.2318C40.6894 14.2318 42.2829 12.6383 42.2829 10.6725C42.2829 8.70681 40.6894 7.11328 38.7237 7.11328C36.7579 7.11328 35.1644 8.70681 35.1644 10.6725C35.1644 12.6383 36.7579 14.2318 38.7237 14.2318Z'
        fill={getColor(color)}
      />
      <path
        d='M38.7237 28.8867C40.6894 28.8867 42.2829 27.2932 42.2829 25.3275C42.2829 23.3617 40.6894 21.7682 38.7237 21.7682C36.7579 21.7682 35.1644 23.3617 35.1644 25.3275C35.1644 27.2932 36.7579 28.8867 38.7237 28.8867Z'
        fill={getColor(color)}
      />
      <path
        d='M43.7479 7.11857C45.7136 7.11857 47.3072 5.52502 47.3072 3.55928C47.3072 1.59355 45.7136 0 43.7479 0C41.7822 0 40.1886 1.59355 40.1886 3.55928C40.1886 5.52502 41.7822 7.11857 43.7479 7.11857Z'
        fill={getColor(color)}
      />
      <path
        d='M43.7479 21.7682C45.7136 21.7682 47.3072 20.1746 47.3072 18.2089C47.3072 16.2432 45.7136 14.6496 43.7479 14.6496C41.7822 14.6496 40.1886 16.2432 40.1886 18.2089C40.1886 20.1746 41.7822 21.7682 43.7479 21.7682Z'
        fill={getColor(color)}
      />
      <path
        d='M43.7479 36C45.7136 36 47.3072 34.4065 47.3072 32.4407C47.3072 30.475 45.7136 28.8815 43.7479 28.8815C41.7822 28.8815 40.1886 30.475 40.1886 32.4407C40.1886 34.4065 41.7822 36 43.7479 36Z'
        fill={getColor(color)}
      />
      <path
        d='M27.628 28.0458C29.2462 28.0458 30.5579 26.7341 30.5579 25.1159C30.5579 23.4978 29.2462 22.186 27.628 22.186C26.0099 22.186 24.6981 23.4978 24.6981 25.1159C24.6981 26.7341 26.0099 28.0458 27.628 28.0458Z'
        fill={getColor(color)}
      />
      <path
        d='M11.9312 34.3235C12.9711 34.3235 13.814 33.4805 13.814 32.4407C13.814 31.4009 12.9711 30.558 11.9312 30.558C10.8914 30.558 10.0485 31.4009 10.0485 32.4407C10.0485 33.4805 10.8914 34.3235 11.9312 34.3235Z'
        fill={getColor(color)}
      />
      <path
        d='M11.9312 20.0917C12.9711 20.0917 13.814 19.2487 13.814 18.2089C13.814 17.1691 12.9711 16.3261 11.9312 16.3261C10.8914 16.3261 10.0485 17.1691 10.0485 18.2089C10.0485 19.2487 10.8914 20.0917 11.9312 20.0917Z'
        fill={getColor(color)}
      />
      <path
        d='M11.9312 5.44205C12.9711 5.44205 13.814 4.5991 13.814 3.55928C13.814 2.51946 12.9711 1.67651 11.9312 1.67651C10.8914 1.67651 10.0485 2.51946 10.0485 3.55928C10.0485 4.5991 10.8914 5.44205 11.9312 5.44205Z'
        fill={getColor(color)}
      />
      <path
        d='M6.48922 26.7924C7.29829 26.7924 7.95418 26.1366 7.95418 25.3275C7.95418 24.5184 7.29829 23.8625 6.48922 23.8625C5.68014 23.8625 5.02426 24.5184 5.02426 25.3275C5.02426 26.1366 5.68014 26.7924 6.48922 26.7924Z'
        fill={getColor(color)}
      />
      <path
        d='M16.9555 12.9731C18.2261 12.9731 19.2561 11.9431 19.2561 10.6725C19.2561 9.40195 18.2261 8.37196 16.9555 8.37196C15.6849 8.37196 14.6549 9.40195 14.6549 10.6725C14.6549 11.9431 15.6849 12.9731 16.9555 12.9731Z'
        fill={getColor(color)}
      />
    </svg>
  )
}

export const NewPlaceIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#PlaceIcon1)'>
        <path
          d='M7.07082 11.2791C7.71286 11.2791 8.23333 10.7586 8.23333 10.1166C8.23333 9.47454 7.71286 8.95407 7.07082 8.95407C6.42879 8.95407 5.90833 9.47454 5.90833 10.1166C5.90833 10.7586 6.42879 11.2791 7.07082 11.2791Z'
          fill={getColor(color)}
        />
        <path
          d='M12.9541 11.2791C13.5962 11.2791 14.1166 10.7586 14.1166 10.1166C14.1166 9.47454 13.5962 8.95407 12.9541 8.95407C12.3121 8.95407 11.7916 9.47454 11.7916 10.1166C11.7916 10.7586 12.3121 11.2791 12.9541 11.2791Z'
          fill={getColor(color)}
        />
        <path
          d='M10.0125 20C10.6545 20 11.175 19.4796 11.175 18.8375C11.175 18.1955 10.6545 17.675 10.0125 17.675C9.37044 17.675 8.84998 18.1955 8.84998 18.8375C8.84998 19.4796 9.37044 20 10.0125 20Z'
          fill={getColor(color)}
        />
        <path
          d='M10.0125 14.1829C10.6545 14.1829 11.175 13.6625 11.175 13.0204C11.175 12.3784 10.6545 11.8579 10.0125 11.8579C9.37044 11.8579 8.84998 12.3784 8.84998 13.0204C8.84998 13.6625 9.37044 14.1829 10.0125 14.1829Z'
          fill={getColor(color)}
        />
        <path
          d='M4.13333 8.24544C4.77536 8.24544 5.29583 7.72497 5.29583 7.08294C5.29583 6.44091 4.77536 5.92044 4.13333 5.92044C3.49129 5.92044 2.97083 6.44091 2.97083 7.08294C2.97083 7.72497 3.49129 8.24544 4.13333 8.24544Z'
          fill={getColor(color)}
        />
        <path
          d='M15.8958 8.24544C16.5378 8.24544 17.0583 7.72497 17.0583 7.08294C17.0583 6.44091 16.5378 5.92044 15.8958 5.92044C15.2537 5.92044 14.7333 6.44091 14.7333 7.08294C14.7333 7.72497 15.2537 8.24544 15.8958 8.24544Z'
          fill={getColor(color)}
        />
        <path
          d='M7.07082 5.30828C7.71286 5.30828 8.23333 4.78781 8.23333 4.14578C8.23333 3.50375 7.71286 2.98328 7.07082 2.98328C6.42879 2.98328 5.90833 3.50375 5.90833 4.14578C5.90833 4.78781 6.42879 5.30828 7.07082 5.30828Z'
          fill={getColor(color)}
        />
        <path
          d='M4.13333 5.30828C4.77536 5.30828 5.29583 4.78781 5.29583 4.14578C5.29583 3.50375 4.77536 2.98328 4.13333 2.98328C3.49129 2.98328 2.97083 3.50375 2.97083 4.14578C2.97083 4.78781 3.49129 5.30828 4.13333 5.30828Z'
          fill={getColor(color)}
        />
        <path
          d='M10.0125 5.30828C10.6545 5.30828 11.175 4.78781 11.175 4.14578C11.175 3.50375 10.6545 2.98328 10.0125 2.98328C9.37044 2.98328 8.84998 3.50375 8.84998 4.14578C8.84998 4.78781 9.37044 5.30828 10.0125 5.30828Z'
          fill={getColor(color)}
        />
        <path
          d='M12.9541 5.30828C13.5962 5.30828 14.1166 4.78781 14.1166 4.14578C14.1166 3.50375 13.5962 2.98328 12.9541 2.98328C12.3121 2.98328 11.7916 3.50375 11.7916 4.14578C11.7916 4.78781 12.3121 5.30828 12.9541 5.30828Z'
          fill={getColor(color)}
        />
        <path
          d='M15.8958 5.30828C16.5378 5.30828 17.0583 4.78781 17.0583 4.14578C17.0583 3.50375 16.5378 2.98328 15.8958 2.98328C15.2537 2.98328 14.7333 3.50375 14.7333 4.14578C14.7333 4.78781 15.2537 5.30828 15.8958 5.30828Z'
          fill={getColor(color)}
        />
        <path
          d='M4.13333 11.192C4.77536 11.192 5.29583 10.6715 5.29583 10.0295C5.29583 9.38744 4.77536 8.86697 4.13333 8.86697C3.49129 8.86697 2.97083 9.38744 2.97083 10.0295C2.97083 10.6715 3.49129 11.192 4.13333 11.192Z'
          fill={getColor(color)}
        />
        <path
          d='M10.0125 11.2791C10.6545 11.2791 11.175 10.7586 11.175 10.1166C11.175 9.47454 10.6545 8.95407 10.0125 8.95407C9.37044 8.95407 8.84998 9.47454 8.84998 10.1166C8.84998 10.7586 9.37044 11.2791 10.0125 11.2791Z'
          fill={getColor(color)}
        />
        <path
          d='M15.8958 11.2791C16.5378 11.2791 17.0583 10.7586 17.0583 10.1166C17.0583 9.47454 16.5378 8.95407 15.8958 8.95407C15.2537 8.95407 14.7333 9.47454 14.7333 10.1166C14.7333 10.7586 15.2537 11.2791 15.8958 11.2791Z'
          fill={getColor(color)}
        />
        <path
          d='M7.07082 14.0335C7.71286 14.0335 8.23333 13.513 8.23333 12.871C8.23333 12.229 7.71286 11.7085 7.07082 11.7085C6.42879 11.7085 5.90833 12.229 5.90833 12.871C5.90833 13.513 6.42879 14.0335 7.07082 14.0335Z'
          fill={getColor(color)}
        />
        <path
          d='M10.0125 17.004C10.6545 17.004 11.175 16.4835 11.175 15.8415C11.175 15.1995 10.6545 14.679 10.0125 14.679C9.37044 14.679 8.84998 15.1995 8.84998 15.8415C8.84998 16.4835 9.37044 17.004 10.0125 17.004Z'
          fill={getColor(color)}
        />
        <path
          d='M12.9541 14.1829C13.5962 14.1829 14.1166 13.6625 14.1166 13.0204C14.1166 12.3784 13.5962 11.8579 12.9541 11.8579C12.3121 11.8579 11.7916 12.3784 11.7916 13.0204C11.7916 13.6625 12.3121 14.1829 12.9541 14.1829Z'
          fill={getColor(color)}
        />
        <path
          d='M7.07082 8.24544C7.71286 8.24544 8.23333 7.72497 8.23333 7.08294C8.23333 6.44091 7.71286 5.92044 7.07082 5.92044C6.42879 5.92044 5.90833 6.44091 5.90833 7.08294C5.90833 7.72497 6.42879 8.24544 7.07082 8.24544Z'
          fill={getColor(color)}
        />
        <path
          d='M12.9541 8.24544C13.5962 8.24544 14.1166 7.72497 14.1166 7.08294C14.1166 6.44091 13.5962 5.92044 12.9541 5.92044C12.3121 5.92044 11.7916 6.44091 11.7916 7.08294C11.7916 7.72497 12.3121 8.24544 12.9541 8.24544Z'
          fill={getColor(color)}
        />
        <path
          d='M7.07082 2.37108C7.71286 2.37108 8.23333 1.85061 8.23333 1.20858C8.23333 0.566551 7.71286 0.0460815 7.07082 0.0460815C6.42879 0.0460815 5.90833 0.566551 5.90833 1.20858C5.90833 1.85061 6.42879 2.37108 7.07082 2.37108Z'
          fill={getColor(color)}
        />
        <path
          d='M10.0125 2.37108C10.6545 2.37108 11.175 1.85061 11.175 1.20858C11.175 0.566551 10.6545 0.0460815 10.0125 0.0460815C9.37044 0.0460815 8.84998 0.566551 8.84998 1.20858C8.84998 1.85061 9.37044 2.37108 10.0125 2.37108Z'
          fill={getColor(color)}
        />
        <path
          d='M12.9541 2.37108C13.5962 2.37108 14.1166 1.85061 14.1166 1.20858C14.1166 0.566551 13.5962 0.0460815 12.9541 0.0460815C12.3121 0.0460815 11.7916 0.566551 11.7916 1.20858C11.7916 1.85061 12.3121 2.37108 12.9541 2.37108Z'
          fill={getColor(color)}
        />
      </g>
      <defs>
        <clipPath id='PlaceIcon1'>
          <rect width='20' height='20' fill={getColor(color)} />
        </clipPath>
      </defs>
    </svg>
  )
}

export const InfoIcon = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.49587 10.2785C10.1379 10.2785 10.6584 9.75799 10.6584 9.11596C10.6584 8.47393 10.1379 7.95346 9.49587 7.95346C8.85384 7.95346 8.33337 8.47393 8.33337 9.11596C8.33337 9.75799 8.85384 10.2785 9.49587 10.2785Z'
        fill={getColor(color)}
      />
      <path
        d='M9.49587 4.325C10.1379 4.325 10.6584 3.80453 10.6584 3.1625C10.6584 2.52047 10.1379 2 9.49587 2C8.85384 2 8.33337 2.52047 8.33337 3.1625C8.33337 3.80453 8.85384 4.325 9.49587 4.325Z'
        fill={getColor(color)}
      />
      <path
        d='M12.2459 10.2785C12.8879 10.2785 13.4084 9.75799 13.4084 9.11596C13.4084 8.47393 12.8879 7.95346 12.2459 7.95346C11.6038 7.95346 11.0834 8.47393 11.0834 9.11596C11.0834 9.75799 11.6038 10.2785 12.2459 10.2785Z'
        fill={getColor(color)}
      />
      <path
        d='M12.2459 4.325C12.8879 4.325 13.4084 3.80453 13.4084 3.1625C13.4084 2.52047 12.8879 2 12.2459 2C11.6038 2 11.0834 2.52047 11.0834 3.1625C11.0834 3.80453 11.6038 4.325 12.2459 4.325Z'
        fill={getColor(color)}
      />
      <path
        d='M9.49587 13.1837C10.1379 13.1837 10.6584 12.6633 10.6584 12.0212C10.6584 11.3792 10.1379 10.8587 9.49587 10.8587C8.85384 10.8587 8.33337 11.3792 8.33337 12.0212C8.33337 12.6633 8.85384 13.1837 9.49587 13.1837Z'
        fill={getColor(color)}
      />
      <path
        d='M12.2459 13.1837C12.8879 13.1837 13.4084 12.6633 13.4084 12.0212C13.4084 11.3792 12.8879 10.8587 12.2459 10.8587C11.6038 10.8587 11.0834 11.3792 11.0834 12.0212C11.0834 12.6633 11.6038 13.1837 12.2459 13.1837Z'
        fill={getColor(color)}
      />
      <path
        d='M9.49587 16.0922C10.1379 16.0922 10.6584 15.5718 10.6584 14.9297C10.6584 14.2877 10.1379 13.7672 9.49587 13.7672C8.85384 13.7672 8.33337 14.2877 8.33337 14.9297C8.33337 15.5718 8.85384 16.0922 9.49587 16.0922Z'
        fill={getColor(color)}
      />
      <path
        d='M12.2459 16.0922C12.8879 16.0922 13.4084 15.5718 13.4084 14.9297C13.4084 14.2877 12.8879 13.7672 12.2459 13.7672C11.6038 13.7672 11.0834 14.2877 11.0834 14.9297C11.0834 15.5718 11.6038 16.0922 12.2459 16.0922Z'
        fill={getColor(color)}
      />
      <path
        d='M9.49587 19.0008C10.1379 19.0008 10.6584 18.4803 10.6584 17.8383C10.6584 17.1963 10.1379 16.6758 9.49587 16.6758C8.85384 16.6758 8.33337 17.1963 8.33337 17.8383C8.33337 18.4803 8.85384 19.0008 9.49587 19.0008Z'
        fill={getColor(color)}
      />
      <path
        d='M12.2459 19.0008C12.8879 19.0008 13.4084 18.4803 13.4084 17.8383C13.4084 17.1963 12.8879 16.6758 12.2459 16.6758C11.6038 16.6758 11.0834 17.1963 11.0834 17.8383C11.0834 18.4803 11.6038 19.0008 12.2459 19.0008Z'
        fill={getColor(color)}
      />
    </svg>
  )
}

export const AssociationMagazineLogo = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width='1087'
      height='89'
      viewBox='0 0 1087 89'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.6899 36.6V50.136H46.8339V63.96H16.6899V87H0.849861V22.68H50.5779V36.6H16.6899ZM82.6089 15.192C81.0089 16.728 78.9609 17.496 76.4649 17.496C73.9689 17.496 71.9209 16.728 70.3209 15.192C68.7209 13.592 67.9209 11.576 67.9209 9.144C67.9209 6.83999 68.7209 4.856 70.3209 3.192C71.9849 1.528 74.0329 0.695995 76.4649 0.695995C78.8969 0.695995 80.9449 1.528 82.6089 3.192C84.2729 4.856 85.1049 6.83999 85.1049 9.144C85.1049 11.576 84.2729 13.592 82.6089 15.192ZM104.497 15.192C102.897 16.728 100.849 17.496 98.3529 17.496C95.8569 17.496 93.8089 16.728 92.2089 15.192C90.6089 13.592 89.8089 11.576 89.8089 9.144C89.8089 6.83999 90.6089 4.856 92.2089 3.192C93.8729 1.528 95.9209 0.695995 98.3529 0.695995C100.785 0.695995 102.833 1.528 104.497 3.192C106.161 4.856 106.993 6.83999 106.993 9.144C106.993 11.576 106.161 13.592 104.497 15.192ZM63.0249 31.032C69.6809 24.504 77.8089 21.24 87.4089 21.24C97.0089 21.24 105.105 24.504 111.697 31.032C118.353 37.56 121.681 45.528 121.681 54.936C121.681 64.28 118.353 72.216 111.697 78.744C105.105 85.208 97.0089 88.44 87.4089 88.44C77.8089 88.44 69.6809 85.208 63.0249 78.744C56.4329 72.216 53.1369 64.28 53.1369 54.936C53.1369 45.528 56.4329 37.56 63.0249 31.032ZM74.2569 68.568C77.7769 72.152 82.1609 73.944 87.4089 73.944C92.6569 73.944 97.0409 72.152 100.561 68.568C104.081 64.92 105.841 60.376 105.841 54.936C105.841 49.432 104.081 44.856 100.561 41.208C97.0409 37.56 92.6569 35.736 87.4089 35.736C82.1609 35.736 77.7769 37.56 74.2569 41.208C70.7369 44.856 68.9769 49.432 68.9769 54.936C68.9769 60.376 70.7369 64.92 74.2569 68.568ZM186.69 87H167.586L148.194 64.92H143.586V87H127.746V22.68H160.29C167.266 22.68 172.866 24.632 177.09 28.536C181.314 32.376 183.426 37.432 183.426 43.704C183.426 48.952 181.922 53.4 178.914 57.048C175.906 60.632 171.778 63 166.53 64.152L186.69 87ZM143.586 51.672H158.562C161.378 51.672 163.618 50.968 165.282 49.56C167.01 48.152 167.874 46.264 167.874 43.896C167.874 41.592 167.01 39.736 165.282 38.328C163.618 36.92 161.378 36.216 158.562 36.216H143.586V51.672ZM240.134 73.368V87H190.022V22.68H239.846V36.312H205.862V48.408H237.062V61.272H205.862V73.368H240.134ZM308.582 22.68V87H295.526L262.982 49.752V87H247.142V22.68H260.294L292.838 61.08V22.68H308.582ZM332.759 87H316.919V22.68H332.759V87ZM402.479 22.68V87H389.423L356.879 49.752V87H341.039V22.68H354.191L386.735 61.08V22.68H402.479ZM440.767 49.08H476.191C476.447 51.128 476.575 53.08 476.575 54.936C476.575 64.664 473.439 72.696 467.167 79.032C460.895 85.304 452.927 88.44 443.263 88.44C433.535 88.44 425.311 85.208 418.591 78.744C411.935 72.28 408.607 64.312 408.607 54.84C408.607 45.432 411.903 37.496 418.495 31.032C425.151 24.504 433.311 21.24 442.975 21.24C450.335 21.24 456.863 22.936 462.559 26.328C468.255 29.656 472.191 34.392 474.367 40.536L459.103 44.952C455.967 38.808 450.591 35.736 442.975 35.736C437.727 35.736 433.343 37.56 429.823 41.208C426.303 44.856 424.543 49.4 424.543 54.84C424.543 60.28 426.335 64.856 429.919 68.568C433.567 72.216 438.079 74.04 443.455 74.04C447.615 74.04 451.167 73.016 454.111 70.968C457.119 68.92 459.231 66.104 460.447 62.52H440.767V49.08ZM507.902 21.24C514.942 21.24 520.83 22.904 525.566 26.232C530.302 29.496 533.278 34.04 534.494 39.864L518.942 43.032C518.366 40.152 517.022 37.944 514.91 36.408C512.798 34.808 510.398 34.008 507.71 34.008C505.15 34.008 503.07 34.648 501.47 35.928C499.87 37.144 499.07 38.68 499.07 40.536C499.07 43.352 500.798 45.144 504.254 45.912L517.598 48.888C529.374 51.512 535.262 57.752 535.262 67.608C535.262 74.2 532.734 79.32 527.678 82.968C522.622 86.616 516.318 88.44 508.766 88.44C501.278 88.44 494.91 86.744 489.662 83.352C484.478 79.896 481.47 75.096 480.638 68.952L496.958 65.784C498.494 72.12 502.718 75.288 509.63 75.288C512.574 75.288 514.878 74.68 516.542 73.464C518.27 72.248 519.134 70.648 519.134 68.664C519.134 67.128 518.686 65.912 517.79 65.016C516.958 64.12 515.422 63.448 513.182 63L499.742 60.12C488.222 57.496 482.462 51.288 482.462 41.496C482.462 35.288 484.798 30.36 489.47 26.712C494.142 23.064 500.286 21.24 507.902 21.24ZM616.044 22.68V87H600.684V54.936L583.884 87H574.092L557.196 54.744V87H541.836V22.68H557.388L578.988 62.52L600.588 22.68H616.044ZM688.685 87H671.789L667.277 75.288H640.205L635.693 87H618.701L645.581 22.68H661.805L688.685 87ZM661.997 61.656L653.741 40.536L645.581 61.656H661.997ZM719.358 49.08H754.782C755.038 51.128 755.166 53.08 755.166 54.936C755.166 64.664 752.03 72.696 745.758 79.032C739.486 85.304 731.518 88.44 721.854 88.44C712.126 88.44 703.902 85.208 697.182 78.744C690.526 72.28 687.198 64.312 687.198 54.84C687.198 45.432 690.494 37.496 697.086 31.032C703.742 24.504 711.902 21.24 721.566 21.24C728.926 21.24 735.454 22.936 741.15 26.328C746.846 29.656 750.782 34.392 752.958 40.536L737.694 44.952C734.558 38.808 729.182 35.736 721.566 35.736C716.318 35.736 711.934 37.56 708.414 41.208C704.894 44.856 703.134 49.4 703.134 54.84C703.134 60.28 704.926 64.856 708.51 68.568C712.158 72.216 716.67 74.04 722.046 74.04C726.206 74.04 729.758 73.016 732.702 70.968C735.71 68.92 737.822 66.104 739.038 62.52H719.358V49.08ZM822.781 87H805.885L801.373 75.288H774.301L769.789 87H752.797L779.677 22.68H795.901L822.781 87ZM796.093 61.656L787.837 40.536L779.677 61.656H796.093ZM849.077 21.24C856.117 21.24 862.005 22.904 866.741 26.232C871.477 29.496 874.453 34.04 875.669 39.864L860.117 43.032C859.541 40.152 858.197 37.944 856.085 36.408C853.973 34.808 851.573 34.008 848.885 34.008C846.325 34.008 844.245 34.648 842.645 35.928C841.045 37.144 840.245 38.68 840.245 40.536C840.245 43.352 841.973 45.144 845.429 45.912L858.773 48.888C870.549 51.512 876.437 57.752 876.437 67.608C876.437 74.2 873.909 79.32 868.853 82.968C863.797 86.616 857.493 88.44 849.941 88.44C842.453 88.44 836.085 86.744 830.837 83.352C825.653 79.896 822.645 75.096 821.813 68.952L838.133 65.784C839.669 72.12 843.893 75.288 850.805 75.288C853.749 75.288 856.053 74.68 857.717 73.464C859.445 72.248 860.309 70.648 860.309 68.664C860.309 67.128 859.861 65.912 858.965 65.016C858.133 64.12 856.597 63.448 854.357 63L840.917 60.12C829.397 57.496 823.637 51.288 823.637 41.496C823.637 35.288 825.973 30.36 830.645 26.712C835.317 23.064 841.461 21.24 849.077 21.24ZM898.851 87H883.011V22.68H898.851V87ZM967.611 22.68V87H954.555L922.011 49.752V87H906.171V22.68H919.323L951.867 61.08V22.68H967.611ZM1026.06 73.368V87H975.947V22.68H1025.77V36.312H991.787V48.408H1022.99V61.272H991.787V73.368H1026.06ZM1086.83 36.504H1066V87H1050.25V36.504H1029.42V22.68H1086.83V36.504Z'
        fill={getColor(color)}
      />
    </svg>
  )
}

export const MagazineLogo = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0)'>
        <path
          d='M2.79999 16C3.62841 16 4.29999 15.3284 4.29999 14.5C4.29999 13.6716 3.62841 13 2.79999 13C1.97156 13 1.29999 13.6716 1.29999 14.5C1.29999 15.3284 1.97156 16 2.79999 16Z'
          fill={getColor(color)}
        />
        <path
          d='M2.79999 8C3.62841 8 4.29999 7.32843 4.29999 6.5C4.29999 5.67157 3.62841 5 2.79999 5C1.97156 5 1.29999 5.67157 1.29999 6.5C1.29999 7.32843 1.97156 8 2.79999 8Z'
          fill={getColor(color)}
        />
        <path
          d='M2.79999 20C3.62841 20 4.29999 19.3284 4.29999 18.5C4.29999 17.6716 3.62841 17 2.79999 17C1.97156 17 1.29999 17.6716 1.29999 18.5C1.29999 19.3284 1.97156 20 2.79999 20Z'
          fill={getColor(color)}
        />
        <path
          d='M2.79999 24C3.62841 24 4.29999 23.3284 4.29999 22.5C4.29999 21.6716 3.62841 21 2.79999 21C1.97156 21 1.29999 21.6716 1.29999 22.5C1.29999 23.3284 1.97156 24 2.79999 24Z'
          fill={getColor(color)}
        />
        <path
          d='M2.79999 12C3.62841 12 4.29999 11.3284 4.29999 10.5C4.29999 9.67157 3.62841 9 2.79999 9C1.97156 9 1.29999 9.67157 1.29999 10.5C1.29999 11.3284 1.97156 12 2.79999 12Z'
          fill={getColor(color)}
        />
        <path
          d='M2.79999 4C3.62841 4 4.29999 3.32843 4.29999 2.5C4.29999 1.67157 3.62841 1 2.79999 1C1.97156 1 1.29999 1.67157 1.29999 2.5C1.29999 3.32843 1.97156 4 2.79999 4Z'
          fill={getColor(color)}
        />
        <path
          d='M8.92484 12.0808C9.73723 11.9186 10.2643 11.1285 10.1021 10.3162C9.93988 9.50377 9.14981 8.97669 8.33742 9.1389C7.52503 9.30112 6.99795 10.0912 7.16017 10.9036C7.32238 11.716 8.11245 12.243 8.92484 12.0808Z'
          fill={getColor(color)}
        />
        <path
          d='M13.9248 12.0808C14.7372 11.9186 15.2643 11.1285 15.1021 10.3162C14.9399 9.50377 14.1498 8.97669 13.3374 9.1389C12.525 9.30112 11.998 10.0912 12.1602 10.9036C12.3224 11.716 13.1125 12.243 13.9248 12.0808Z'
          fill={getColor(color)}
        />
        <path
          d='M18.9248 12.0808C19.7372 11.9186 20.2643 11.1285 20.1021 10.3162C19.9399 9.50377 19.1498 8.97669 18.3374 9.1389C17.525 9.30112 16.998 10.0912 17.1602 10.9036C17.3224 11.716 18.1125 12.243 18.9248 12.0808Z'
          fill={getColor(color)}
        />
        <path
          d='M9.70808 16.0032C10.5205 15.841 11.0475 15.0509 10.8853 14.2385C10.7231 13.4261 9.93304 12.8991 9.12065 13.0613C8.30826 13.2235 7.78119 14.0136 7.9434 14.8259C8.10561 15.6383 8.89569 16.1654 9.70808 16.0032Z'
          fill={getColor(color)}
        />
        <path
          d='M14.7081 16.0032C15.5205 15.841 16.0475 15.0509 15.8853 14.2385C15.7231 13.4261 14.933 12.8991 14.1207 13.0613C13.3083 13.2235 12.7812 14.0136 12.9434 14.8259C13.1056 15.6383 13.8957 16.1654 14.7081 16.0032Z'
          fill={getColor(color)}
        />
        <path
          d='M19.7081 16.0032C20.5205 15.841 21.0475 15.0509 20.8853 14.2385C20.7231 13.4261 19.933 12.8991 19.1207 13.0613C18.3083 13.2235 17.7812 14.0136 17.9434 14.8259C18.1056 15.6383 18.8957 16.1654 19.7081 16.0032Z'
          fill={getColor(color)}
        />
        <path
          d='M8.14161 8.15822C8.954 7.99601 9.48107 7.20594 9.31886 6.39355C9.15665 5.58116 8.36658 5.05408 7.55418 5.2163C6.74179 5.37851 6.21472 6.16858 6.37693 6.98097C6.53915 7.79336 7.32922 8.32044 8.14161 8.15822Z'
          fill={getColor(color)}
        />
        <path
          d='M13.1416 8.15822C13.954 7.99601 14.4811 7.20594 14.3189 6.39355C14.1566 5.58116 13.3666 5.05408 12.5542 5.2163C11.7418 5.37851 11.2147 6.16858 11.3769 6.98097C11.5391 7.79336 12.3292 8.32044 13.1416 8.15822Z'
          fill={getColor(color)}
        />
        <path
          d='M18.1416 8.15822C18.954 7.99601 19.4811 7.20594 19.3189 6.39355C19.1566 5.58116 18.3666 5.05408 17.5542 5.2163C16.7418 5.37851 16.2147 6.16858 16.3769 6.98097C16.5391 7.79336 17.3292 8.32044 18.1416 8.15822Z'
          fill={getColor(color)}
        />
        <path
          d='M7.35838 4.23562C8.17077 4.0734 8.69784 3.28333 8.53563 2.47094C8.37341 1.65855 7.58334 1.13148 6.77095 1.29369C5.95856 1.4559 5.43149 2.24598 5.5937 3.05837C5.75591 3.87076 6.54599 4.39783 7.35838 4.23562Z'
          fill={getColor(color)}
        />
        <path
          d='M12.3584 4.23562C13.1708 4.0734 13.6978 3.28333 13.5356 2.47094C13.3734 1.65855 12.5833 1.13148 11.771 1.29369C10.9586 1.4559 10.4315 2.24598 10.5937 3.05837C10.7559 3.87076 11.546 4.39783 12.3584 4.23562Z'
          fill={getColor(color)}
        />
        <path
          d='M17.3584 4.23562C18.1708 4.0734 18.6978 3.28333 18.5356 2.47094C18.3734 1.65855 17.5833 1.13148 16.771 1.29369C15.9586 1.4559 15.4315 2.24598 15.5937 3.05837C15.7559 3.87076 16.546 4.39783 17.3584 4.23562Z'
          fill={getColor(color)}
        />
        <path
          d='M10.4913 19.9258C11.3037 19.7636 11.8308 18.9735 11.6686 18.1611C11.5063 17.3487 10.7163 16.8217 9.90389 16.9839C9.0915 17.1461 8.56442 17.9362 8.72663 18.7486C8.88885 19.5609 9.67892 20.088 10.4913 19.9258Z'
          fill={getColor(color)}
        />
        <path
          d='M15.4913 19.9258C16.3037 19.7636 16.8308 18.9735 16.6686 18.1611C16.5063 17.3487 15.7163 16.8217 14.9039 16.9839C14.0915 17.1461 13.5644 17.9362 13.7266 18.7486C13.8888 19.5609 14.6789 20.088 15.4913 19.9258Z'
          fill={getColor(color)}
        />
        <path
          d='M20.4913 19.9258C21.3037 19.7636 21.8308 18.9735 21.6686 18.1611C21.5063 17.3487 20.7163 16.8217 19.9039 16.9839C19.0915 17.1461 18.5644 17.9362 18.7266 18.7486C18.8888 19.5609 19.6789 20.088 20.4913 19.9258Z'
          fill={getColor(color)}
        />
        <path
          d='M11.2745 23.8484C12.0869 23.6862 12.614 22.8961 12.4518 22.0837C12.2896 21.2713 11.4995 20.7443 10.6871 20.9065C9.87473 21.0687 9.34766 21.8588 9.50987 22.6712C9.67208 23.4835 10.4622 24.0106 11.2745 23.8484Z'
          fill={getColor(color)}
        />
        <path
          d='M16.2745 23.8484C17.0869 23.6862 17.614 22.8961 17.4518 22.0837C17.2896 21.2713 16.4995 20.7443 15.6871 20.9065C14.8747 21.0687 14.3477 21.8588 14.5099 22.6712C14.6721 23.4835 15.4622 24.0106 16.2745 23.8484Z'
          fill={getColor(color)}
        />
        <path
          d='M21.2745 23.8484C22.0869 23.6862 22.614 22.8961 22.4518 22.0837C22.2896 21.2713 21.4995 20.7443 20.6871 20.9065C19.8747 21.0687 19.3477 21.8588 19.5099 22.6712C19.6721 23.4835 20.4622 24.0106 21.2745 23.8484Z'
          fill={getColor(color)}
        />
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill={getColor(color)} />
        </clipPath>
      </defs>
    </svg>
  )
}

export const LogoNegative = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width='167'
      height='24'
      viewBox='0 0 167 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M48.469 6.30859V17.4858H46.544L40.3562 10.2858V17.4858H38.0874V6.30859H40.0125L46.2002 13.7144V6.30859H48.469Z'
        fill={getColor(color)}
      />
      <path
        d='M58.5755 13.9198H52.1815C52.3878 15.1541 53.2816 15.8398 54.2441 15.8398C54.9316 15.8398 55.6879 15.7713 56.3067 14.7427L58.3005 15.1541C57.5442 16.8684 56.1004 17.7598 54.2441 17.7598C51.9065 17.7598 49.9814 15.977 49.9814 13.3712C49.9814 10.7655 51.9065 8.91406 54.3129 8.91406C56.5129 8.91406 58.438 10.6284 58.5755 13.1655V13.9198ZM52.2503 12.3427H56.3067C56.0317 11.2455 55.2066 10.8341 54.3129 10.8341C53.4878 10.8341 52.5253 11.3141 52.2503 12.3427Z'
        fill={getColor(color)}
      />
      <path
        d='M71.1566 9.12036L68.4065 17.4861H66.4127L64.7626 12.549L63.1126 17.4861H61.1188L58.3687 9.12036H60.5687L62.2188 14.2633L63.9376 9.12036H65.6564L67.3752 14.2633L69.0253 9.12036H71.1566Z'
        fill={getColor(color)}
      />
      <path
        d='M81.1244 13.3029C81.1244 15.9086 79.1306 17.6915 76.9993 17.6915C75.8305 17.6915 74.9367 17.3486 74.2492 16.8001V17.4858H72.0491V5.41711H74.2492V9.80572C74.9367 9.18857 75.8992 8.91428 76.9993 8.91428C79.1306 8.91428 81.1244 10.6972 81.1244 13.3029ZM78.9931 13.3029C78.9931 11.7943 77.9618 10.7657 76.6555 10.7657C75.4867 10.7657 74.2492 11.7257 74.2492 13.3029C74.2492 14.8115 75.4179 15.7715 76.6555 15.7715C77.9618 15.7715 78.9931 14.88 78.9931 13.3029Z'
        fill={getColor(color)}
      />
      <path
        d='M90.8908 13.3027C90.8908 15.9084 88.8282 17.6913 86.3531 17.6913C83.878 17.6913 81.8154 15.9084 81.8154 13.3027C81.8154 10.6969 83.878 8.91406 86.3531 8.91406C88.8282 8.91406 90.8908 10.6969 90.8908 13.3027ZM88.6907 13.3027C88.6907 11.7255 87.4531 10.8341 86.3531 10.8341C85.1156 10.8341 83.9468 11.7941 83.9468 13.3027C83.9468 14.8798 85.1843 15.7713 86.3531 15.7713C87.5219 15.7713 88.6907 14.8798 88.6907 13.3027Z'
        fill={getColor(color)}
      />
      <path
        d='M100.515 5.41717V17.4173H98.3152V16.7315C97.6277 17.2801 96.6651 17.623 95.5651 17.623C93.4338 17.623 91.4399 15.8401 91.4399 13.2344C91.4399 10.6286 93.4338 8.7772 95.5651 8.7772C96.7339 8.7772 97.6277 9.12006 98.3152 9.66863V5.28003H100.515V5.41717ZM98.3152 13.3029C98.3152 11.7944 97.1464 10.7658 95.9089 10.7658C94.6026 10.7658 93.5713 11.7258 93.5713 13.3029C93.5713 14.8115 94.6026 15.7715 95.9089 15.7715C97.1464 15.7715 98.3152 14.8801 98.3152 13.3029Z'
        fill={getColor(color)}
      />
      <path
        d='M110.829 9.12036L105.741 20.7776H103.266L104.847 17.1433L101.409 9.12036H103.885L106.085 14.469L108.422 9.12036H110.829Z'
        fill={getColor(color)}
      />
      <path
        d='M118.046 8.36575V11.1086H123.477V13.1658H118.046V17.4858H115.777V6.30859H124.096V8.36575H118.046Z'
        fill={getColor(color)}
      />
      <path
        d='M133.584 9.12048V17.4863H131.384V16.8005C130.697 17.3491 129.734 17.692 128.634 17.692C126.503 17.692 124.509 15.9091 124.509 13.3034C124.509 10.6976 126.503 8.84619 128.634 8.84619C129.803 8.84619 130.697 9.18905 131.384 9.73763V9.05191H133.584V9.12048ZM131.384 13.3034C131.384 11.7948 130.215 10.7662 128.978 10.7662C127.671 10.7662 126.64 11.7262 126.64 13.3034C126.64 14.8119 127.671 15.772 128.978 15.772C130.215 15.772 131.384 14.8805 131.384 13.3034Z'
        fill={getColor(color)}
      />
      <path
        d='M148.849 12.2748V17.4863H146.649V12.7548C146.649 11.6576 145.961 10.9719 144.999 10.9719C143.83 10.9719 143.073 11.7948 143.073 13.5091V17.4863H140.873V12.7548C140.873 11.6576 140.186 10.9719 139.223 10.9719C138.055 10.9719 137.298 11.7948 137.298 13.5091V17.4863H135.098V9.12048H137.298V9.8062C137.917 9.18905 138.673 8.84619 139.773 8.84619C140.873 8.84619 141.905 9.32619 142.523 10.2176C143.211 9.39477 144.242 8.84619 145.549 8.84619C147.336 8.91476 148.849 10.2176 148.849 12.2748Z'
        fill={getColor(color)}
      />
      <path
        d='M152.904 6.6515C152.904 7.40579 152.354 7.95437 151.597 7.95437C150.841 7.95437 150.291 7.40579 150.291 6.6515C150.291 5.96578 150.841 5.34863 151.597 5.34863C152.285 5.34863 152.904 5.96578 152.904 6.6515ZM152.629 17.4859H150.429V9.12009H152.629V17.4859Z'
        fill={getColor(color)}
      />
      <path
        d='M156.754 17.4858H154.554V5.41711H156.754V17.4858Z'
        fill={getColor(color)}
      />
      <path
        d='M167 9.12033L161.912 20.7776H159.437L161.018 17.1432L157.581 9.05176H160.056L162.256 14.4004L164.594 9.05176H167V9.12033Z'
        fill={getColor(color)}
      />
      <path
        d='M11.4133 8.70833C12.2383 8.70833 12.9258 8.02261 12.9258 7.19975C12.9258 6.37688 12.2383 5.69116 11.4133 5.69116C10.657 5.69116 9.96948 6.37688 9.96948 7.19975C9.96948 7.61118 10.107 7.95404 10.382 8.22833C10.657 8.50261 11.0695 8.70833 11.4133 8.70833Z'
        fill={getColor(color)}
      />
      <path
        d='M7.90576 22.9714C8.59328 22.9714 9.21206 22.4228 9.21206 21.7371C9.21206 21.0514 8.66203 20.4342 7.97451 20.4342C7.28698 20.4342 6.73697 20.9828 6.66821 21.6685C6.66821 22.0114 6.80572 22.3542 7.01198 22.5599C7.21823 22.8342 7.56199 22.9714 7.90576 22.9714Z'
        fill={getColor(color)} // fill='#1B1B1B'
      />
      <path
        d='M7.90576 3.63432C8.59328 3.63432 9.21206 3.08575 9.21206 2.40003C9.21206 1.71431 8.66203 1.09717 7.97451 1.09717C7.28698 1.09717 6.73697 1.64574 6.66821 2.33146C6.66821 2.67432 6.80572 3.01718 7.01198 3.22289C7.21823 3.49718 7.56199 3.63432 7.90576 3.63432Z'
        fill={getColor(color)}
      />
      <path
        d='M7.90576 13.3027C8.59328 13.3027 9.21206 12.7541 9.21206 12.0684C9.21206 11.3826 8.66203 10.7655 7.97451 10.7655C7.28698 10.7655 6.73697 11.3141 6.66821 11.9998C6.66821 12.3427 6.80572 12.6855 7.01198 12.8912C7.21823 13.1655 7.56199 13.3027 7.90576 13.3027Z'
        fill={getColor(color)}
      />
      <path
        d='M4.33256 17.8972C4.88258 17.8972 5.36385 17.4172 5.36385 16.8687C5.36385 16.3201 4.88258 15.8401 4.33256 15.8401C3.78254 15.8401 3.30127 16.3201 3.30127 16.8687C3.30127 17.143 3.43878 17.4172 3.57628 17.623C3.78254 17.7601 4.05755 17.8972 4.33256 17.8972Z'
        fill={getColor(color)}
      />
      <path
        d='M18.5634 18.7201C19.5946 18.7201 20.4884 17.8972 20.4884 16.8686C20.4884 15.84 19.6634 14.9486 18.6321 14.9486C17.6008 14.9486 16.707 15.7715 16.707 16.8001C16.707 17.2801 16.9133 17.7601 17.2571 18.1715C17.6008 18.5143 18.0821 18.7201 18.5634 18.7201Z'
        fill={getColor(color)}
      />
      <path
        d='M11.482 8.70833C12.3174 8.70833 12.9946 8.03291 12.9946 7.19975C12.9946 6.36658 12.3174 5.69116 11.482 5.69116C10.6467 5.69116 9.96948 6.36658 9.96948 7.19975C9.96948 8.03291 10.6467 8.70833 11.482 8.70833Z'
        fill={getColor(color)}
      />
      <path
        d='M7.9064 13.3712C8.62785 13.3712 9.2127 12.7879 9.2127 12.0684C9.2127 11.3488 8.62785 10.7655 7.9064 10.7655C7.18495 10.7655 6.6001 11.3488 6.6001 12.0684C6.6001 12.7879 7.18495 13.3712 7.9064 13.3712Z'
        fill={getColor(color)}
      />
      <path
        d='M7.9064 3.7029C8.62785 3.7029 9.2127 3.11959 9.2127 2.40003C9.2127 1.68048 8.62785 1.09717 7.9064 1.09717C7.18495 1.09717 6.6001 1.68048 6.6001 2.40003C6.6001 3.11959 7.18495 3.7029 7.9064 3.7029Z'
        fill={getColor(color)}
      />
      <path
        d='M7.9064 22.9715C8.62785 22.9715 9.2127 22.3881 9.2127 21.6686C9.2127 20.949 8.62785 20.3657 7.9064 20.3657C7.18495 20.3657 6.6001 20.949 6.6001 21.6686C6.6001 22.3881 7.18495 22.9715 7.9064 22.9715Z'
        fill={getColor(color)}
      />
      <path
        d='M4.33256 8.22867C4.90212 8.22867 5.36385 7.76816 5.36385 7.20009C5.36385 6.63202 4.90212 6.17151 4.33256 6.17151C3.76299 6.17151 3.30127 6.63202 3.30127 7.20009C3.30127 7.76816 3.76299 8.22867 4.33256 8.22867Z'
        fill={getColor(color)}
      />
      <path
        d='M4.33256 17.8972C4.90212 17.8972 5.36385 17.4367 5.36385 16.8687C5.36385 16.3006 4.90212 15.8401 4.33256 15.8401C3.76299 15.8401 3.30127 16.3006 3.30127 16.8687C3.30127 17.4367 3.76299 17.8972 4.33256 17.8972Z'
        fill={getColor(color)}
      />
      <path
        d='M0.756279 3.15397C1.17396 3.15397 1.51256 2.81626 1.51256 2.39968C1.51256 1.98309 1.17396 1.64539 0.756279 1.64539C0.338598 1.64539 0 1.98309 0 2.39968C0 2.81626 0.338598 3.15397 0.756279 3.15397Z'
        fill={getColor(color)}
      />
      <path
        d='M0.756279 12.8232C1.17396 12.8232 1.51256 12.4854 1.51256 12.0689C1.51256 11.6523 1.17396 11.3146 0.756279 11.3146C0.338598 11.3146 0 11.6523 0 12.0689C0 12.4854 0.338598 12.8232 0.756279 12.8232Z'
        fill={getColor(color)}
      />
      <path
        d='M0.756279 22.4231C1.17396 22.4231 1.51256 22.0854 1.51256 21.6688C1.51256 21.2523 1.17396 20.9146 0.756279 20.9146C0.338598 20.9146 0 21.2523 0 21.6688C0 22.0854 0.338598 22.4231 0.756279 22.4231Z'
        fill={getColor(color)}
      />
      <path
        d='M15.0548 13.7831C16.004 13.7831 16.7736 13.0156 16.7736 12.0688C16.7736 11.122 16.004 10.3545 15.0548 10.3545C14.1055 10.3545 13.3359 11.122 13.3359 12.0688C13.3359 13.0156 14.1055 13.7831 15.0548 13.7831Z'
        fill={getColor(color)}
      />
      <path
        d='M18.562 18.7886C19.6252 18.7886 20.4871 17.929 20.4871 16.8686C20.4871 15.8082 19.6252 14.9486 18.562 14.9486C17.4988 14.9486 16.637 15.8082 16.637 16.8686C16.637 17.929 17.4988 18.7886 18.562 18.7886Z'
        fill={getColor(color)}
      />
      <path
        d='M22.1385 14.1262C23.2776 14.1262 24.2011 13.2051 24.2011 12.069C24.2011 10.9329 23.2776 10.0118 22.1385 10.0118C20.9994 10.0118 20.0759 10.9329 20.0759 12.069C20.0759 13.2051 20.9994 14.1262 22.1385 14.1262Z'
        fill={getColor(color)}
      />
      <path
        d='M22.1385 23.7261C23.2776 23.7261 24.2011 22.8051 24.2011 21.669C24.2011 20.5328 23.2776 19.6118 22.1385 19.6118C20.9994 19.6118 20.0759 20.5328 20.0759 21.669C20.0759 22.8051 20.9994 23.7261 22.1385 23.7261Z'
        fill={getColor(color)}
      />
      <path
        d='M22.1385 4.45696C23.2776 4.45696 24.2011 3.53594 24.2011 2.39981C24.2011 1.26367 23.2776 0.342651 22.1385 0.342651C20.9994 0.342651 20.0759 1.26367 20.0759 2.39981C20.0759 3.53594 20.9994 4.45696 22.1385 4.45696Z'
        fill={getColor(color)}
      />
      <path
        d='M25.7822 14.5375C25.7822 14.5375 25.7134 14.5375 25.7822 14.5375C25.1634 14.5375 24.6134 14.7432 24.1321 15.2232C23.7196 15.6346 23.4446 16.2518 23.4446 16.8689C23.4446 17.4861 23.6508 18.0346 24.1321 18.5146C24.5446 18.9261 25.1634 19.2004 25.7822 19.2004C27.0197 19.2004 28.051 18.1718 28.1198 16.9375C28.051 15.6346 27.0197 14.5375 25.7822 14.5375Z'
        fill={getColor(color)}
      />
      <path
        d='M25.7126 9.53179C27.0036 9.53179 28.0502 8.48797 28.0502 7.20034C28.0502 5.91272 27.0036 4.8689 25.7126 4.8689C24.4216 4.8689 23.375 5.91272 23.375 7.20034C23.375 8.48797 24.4216 9.53179 25.7126 9.53179Z'
        fill={getColor(color)}
      />
      <path
        d='M25.7126 19.2004C27.0036 19.2004 28.0502 18.1565 28.0502 16.8689C28.0502 15.5813 27.0036 14.5375 25.7126 14.5375C24.4216 14.5375 23.375 15.5813 23.375 16.8689C23.375 18.1565 24.4216 19.2004 25.7126 19.2004Z'
        fill={getColor(color)}
      />
      <path
        d='M29.289 4.66288C30.58 4.66288 31.6266 3.61906 31.6266 2.33144C31.6266 1.04382 30.58 0 29.289 0C27.998 0 26.9514 1.04382 26.9514 2.33144C26.9514 3.61906 27.998 4.66288 29.289 4.66288Z'
        fill={getColor(color)}
      />
      <path
        d='M29.289 14.4C30.58 14.4 31.6266 13.3561 31.6266 12.0685C31.6266 10.7809 30.58 9.73706 29.289 9.73706C27.998 9.73706 26.9514 10.7809 26.9514 12.0685C26.9514 13.3561 27.998 14.4 29.289 14.4Z'
        fill={getColor(color)}
      />
      <path
        d='M29.289 24C30.58 24 31.6266 22.9562 31.6266 21.6686C31.6266 20.381 30.58 19.3372 29.289 19.3372C27.998 19.3372 26.9514 20.381 26.9514 21.6686C26.9514 22.9562 27.998 24 29.289 24Z'
        fill={getColor(color)}
      />
    </svg>
  )
}

export const Dots = ({ id, width, color }) => {
  return (
    <svg
      className={id}
      width={width}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 12.7586C6 13.4483 6.55172 14 7.24138 14C7.93103 14 8.48276 13.4483 8.48276 12.7586C8.48276 12.069 7.93103 11.5172 7.24138 11.5172C6.55172 11.5172 6 12.069 6 12.7586ZM6 10C6 10.6897 6.55172 11.2414 7.24138 11.2414C7.93103 11.2414 8.48276 10.6897 8.48276 10C8.48276 9.31034 7.93103 8.75862 7.24138 8.75862C6.55172 8.75862 6 9.31034 6 10ZM6 7.24138C6 7.93103 6.55172 8.48276 7.24138 8.48276C7.93103 8.48276 8.48276 7.93103 8.48276 7.24138C8.48276 6.55172 7.93103 6 7.24138 6C6.55172 6 6 6.55172 6 7.24138ZM8.75862 10C8.75862 10.6897 9.31034 11.2414 10 11.2414C10.6897 11.2414 11.2414 10.6897 11.2414 10C11.2414 9.31034 10.6897 8.75862 10 8.75862C9.31034 8.75862 8.75862 9.31034 8.75862 10ZM11.5172 10C11.5172 10.6897 12.069 11.2414 12.7586 11.2414C13.4483 11.2414 14 10.6897 14 10C14 9.31034 13.4483 8.75862 12.7586 8.75862C12.069 8.75862 11.5172 9.31034 11.5172 10ZM11.5172 7.24138C11.5172 7.93103 12.069 8.48276 12.7586 8.48276C13.4483 8.48276 14 7.93103 14 7.24138C14 6.55172 13.4483 6 12.7586 6C12.069 6 11.5172 6.55172 11.5172 7.24138ZM11.5172 12.7586C11.5172 13.4483 12.069 14 12.7586 14C13.4483 14 14 13.4483 14 12.7586C14 12.069 13.4483 11.5172 12.7586 11.5172C12.069 11.5172 11.5172 12.069 11.5172 12.7586ZM8.75862 7.24138C8.75862 7.93103 9.31034 8.48276 10 8.48276C10.6897 8.48276 11.2414 7.93103 11.2414 7.24138C11.2414 6.55172 10.6897 6 10 6C9.31034 6 8.75862 6.55172 8.75862 7.24138ZM8.75862 12.7586C8.75862 13.4483 9.31034 14 10 14C10.6897 14 11.2414 13.4483 11.2414 12.7586C11.2414 12.069 10.6897 11.5172 10 11.5172C9.31034 11.5172 8.75862 12.069 8.75862 12.7586Z'
        fill={getColor(color)}
      />
    </svg>
  )
}
export const MaterialIconWarning = ({ id }) => {
  return (
    <svg
      className={id}
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
    >
      <path
        d='M0.666687 14.5002H15.3334L8.00002 1.8335L0.666687 14.5002ZM8.66669 12.5002H7.33335V11.1668H8.66669V12.5002ZM8.66669 9.8335H7.33335V7.16683H8.66669V9.8335Z'
        fill='#F7543E'
      />
    </svg>
  )
}
export const CircledHeart = ({ id }) => {
  return (
    <StyledCircleHeart className={id}>
      <LikeIcon color={'darkPink'} width={48} />
    </StyledCircleHeart>
  )
}

export const FlagSweden = ({ id, width }) => {
  return (
    <svg className={id} width={width} viewBox='0 0 18 18' fill='none'>
      <path
        fill='#006AA7'
        d='M7.495 17.874A9 9 0 0 0 9 18c4.357 0 7.99-3.095 8.822-7.209H7.495v7.083ZM.178 10.791a9.004 9.004 0 0 0 3.684 5.599v-5.6H.178ZM3.862 1.61a9.003 9.003 0 0 0-3.684 5.6h3.684v-5.6Zm13.96 5.599C16.99 3.095 13.357 0 9 0a9 9 0 0 0-1.505.126v7.083h10.327Z'
      />
      <path
        fill='#FECC00'
        d='M3.862 7.208H.178A8.951 8.951 0 0 0 0 9c0 .613.06 1.213.178 1.791h3.684V7.208Zm13.96 0H7.495v3.583h10.327A8.95 8.95 0 0 0 18 9a8.95 8.95 0 0 0-.178-1.792Zm-10.327 0V.125A8.914 8.914 0 0 0 3.862 1.61v5.598h3.633Zm-3.633 3.583v5.599a8.983 8.983 0 0 0 3.633 1.484v-7.082H3.862Zm3.633-3.583H3.862v3.583h3.633V7.208Z'
      />
    </svg>
  )
}
export const FlagFinland = ({ id, width }) => {
  return (
    <svg
      className={id}
      width={width}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#a)'>
        <rect width='18' height='18' fill='#fff' rx='9' />
        <g clip-path='url(#b)'>
          <path fill='#fff' d='M25 0H-4v18h29V0Z' />
          <path fill='#FFFDFA' d='M-4 9h29ZM6.472 0v18Z' />
          <path
            fill='#002F6C'
            fill-rule='evenodd'
            d='M4.056 6.545V0h4.833v6.545H25v4.91H8.889V18H4.056v-6.546H-4V6.545h8.056Z'
            clip-rule='evenodd'
          />
        </g>
      </g>
      <defs>
        <clipPath id='a'>
          <rect width='18' height='18' fill='#fff' rx='9' />
        </clipPath>
        <clipPath id='b'>
          <path fill='#fff' d='M-4 0h29v18H-4z' />
        </clipPath>
      </defs>
    </svg>
  )
}
